
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'ทดสอบ',
	'visualizationSlideoutTitle': 'วิชวลไลเซชัน',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'ป้อนตัวเลข',
	'maxValuePlaceholder': 'ป้อนตัวเลข',
	'customRangeErrorMessage': 'ค่าต้องเป็นตัวเลข',
	'propFillColor': 'เติมสี',
	'propBorderColor': 'สีของเส้นขอบ',
	'propColorPalette': 'พาเล็ตสีปัจจุบัน',
	'propColorPaletteChangeLabel': 'เปลี่ยนพาเล็ตสี',
	'propNewColorPaletteLabel': 'สร้างพาเล็ตสีที่กำหนดเอง',
	'propNewHeatPaletteLabel': 'สร้างพาเล็ตความร้อนที่กำหนดเอง',
	'propDonutRadius': 'รัศมีแบบโดนัท',
	'showTitleLabel': 'แสดงหัวเรื่อง',
	'titleTypeLabel': 'ชนิดหัวเรื่อง',
	'smartTitleLabel': 'หัวเรื่องแบบสมาร์ท',
	'customTitleLabel': 'หัวเรื่องแบบกำหนดเอง',
	'noTitleLabel': 'ไม่มีหัวเรื่อง',
	'propHeatScalePalette': 'พาเล็ตความร้อนปัจจุบัน',
	'propHeatPaletteChangeLabel': 'เปลี่ยนพาเล็ตความร้อน',
	'propMaintainAxisScales': 'รักษาสเกลของแกน',
	'propLineAndSymbolColor': 'สีของเส้นและสัญลักษณ์',
	'propLineAndSymbolPalette': 'พาเล็ตสีของเส้นและสัญลักษณ์',
	'propElementColor': 'สีของอิลิเมนต์',
	'propColumnColor': 'สีคอลัมน์',
	'propColumnPalette': 'พาเล็ตสีคอลัมน์',
	'propColumnHeatPalette': 'พาเล็ตความร้อนของคอลัมน์',
	'propBarColor': 'สีของแท่ง',
	'propGoalColor': 'สีของเป้าหมาย',
	'propToColor': 'เป็นสี',
	'propFromColor': 'จากสี',
	'propNumberValidationErrorMessageId': 'ป้อนตัวเลข',
	'fontSizeAuto': 'อัตโนมัติ',
	'propAutoBinCount': 'จำนวนกลุ่ม',
	'propAutoBinToggle': 'จัดกลุ่มแบบอัตโนมัติ',
	'tabName_general': 'ทั่วไป',
	'tabName_visDetails': 'รายละเอียด',
	'tabName_animation': 'แอนิเมชัน',
	'tabName_mediaDetails': 'รายละเอียดของสื่อบันทึก',
	'tabName_webDetails': 'รายละเอียดของเว็บเพจ',
	'tabName_imageDetails': 'รายละเอียดของรูปภาพ',
	'tabName_visualization': 'วิชวลไลเซชัน',
	'tabName_text': 'ข้อความ',
	'sectionName_colorsAndThemes': 'สีและธีม',
	'sectionName_appearance': 'ลักษณะที่ปรากฏ',
	'sectionName_general': 'ทั่วไป',
	'sectionName_colorPalette': 'สี',
	'sectionName_axis': 'แกน',
	'sectionName_axis_label': 'แกน',
	'sectionName_legend': 'คำอธิบายสัญลักษณ์',
	'sectionName_chart': 'แผนภูมิ',
	'sectionName_regionLayer': 'เลเยอร์ภูมิภาค',
	'sectionName_pointLayer': 'เลเยอร์จุด',
	'sectionName_latLongLayer': 'เลเยอร์ละติจูด/ลองจิจูด',
	'sectionName_pathLayer': 'เลเยอร์พาธ',
	'sectionName_xAxis': 'แกน X',
	'sectionName_yAxis': 'แกน Y',
	'sectionName_xAxis_title': 'หัวเรื่องแกน X',
	'sectionName_yAxis_title': 'หัวเรื่องแกน Y',
	'sectionName_xAxis_label': 'เลเบลแกน X',
	'sectionName_yAxis_label': 'เลเบลแกน Y',
	'sectionName_column_yAxis': 'แกน Y ของคอลัมน์',
	'sectionName_column_yAxis_label': 'เลเบลแกน Y ของคอลัมน์',
	'sectionName_column_yAxis_title': 'หัวเรื่องแกน Y ของคอลัมน์',
	'sectionName_line_yAxis': 'แกน Y ของเส้น',
	'sectionName_line_yAxis_label': 'เลเบลแกน Y ของเส้น',
	'sectionName_line_yAxis_title': 'หัวเรื่องแกน Y ของเส้น',
	'sectionName_title': 'หัวเรื่อง',
	'sectionName_dataValueLabels': 'เลเบลค่าข้อมูล',
	'sectionName_style': 'สไตล์',
	'propTransparencyDescription': 'ทำให้อ็อบเจ็กต์มีความโปร่งแสงมากขึ้นหรือน้อยลง พิมพ์ค่าระหว่าง 0 ถึง 100',
	'smart_annotation_unauthorized': 'หมายเหตุประกอบ: ไม่มีสิทธิ์เข้าถึง',
	'smart_annotation_method': 'หมายเหตุประกอบ: เมธอดที่ไม่ได้รับอนุญาต',
	'smart_annotation_media': 'หมายเหตุประกอบ: ชนิดมีเดียที่ไม่ได้รับอนุญาต',
	'smart_annotation_input': 'หมายเหตุประกอบ: อินพุตไม่ถูกต้อง',
	'smart_annotation_internal': 'หมายเหตุประกอบ: ข้อผิดพลาดระบบภายใน',
	'smart_annotation_generic_error': 'หมายเหตุประกอบ: ข้อผิดพลาดของเซอร์วิส',
	'smart_annotation_dialog_title': 'ข้อมูลเชิงลึก',
	'smart_annotation_Show_Insights': 'แสดงข้อมูลเชิงลึก',
	'smart_annotation_Relationship': 'ความสัมพันธ์คือ',
	'forecast_enter_number': 'ป้อนตัวเลขระหว่าง ',
	'and': ' และ ',
	'smart_errors': 'ข้อผิดพลาดหมายเหตุประกอบ:',
	'smart_warnings': 'คำเตือนหมายเหตุประกอบ:',
	'smart_annotation_insight_icon_title': 'ข้อมูลเชิงลึก',
	'smart_annotations_toggle_on': 'เปิดข้อมูลเชิงลึก',
	'smart_annotations_toggle_off': 'ปิดข้อมูลเชิงลึก',
	'smart_annotation_toggle_on': 'เปิดการสลับ',
	'smart_annotation_toggle_off': 'ปิดการสลับ',
	'smart_annotation_insight_unavailable': 'ข้อมูลเชิงลึกไม่พร้อมใช้งานในขณะนี้',
	'smart_annotation_insight_topBottom_percent_unsupported': 'ข้อมูลเชิงลึกไม่พร้อมใช้งานเมื่อใช้ตัวกรอง % สูงสุดหรือ % ต่ำสุด',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'การคาดการณ์ล่วงหน้าไม่พร้อมใช้งานเมื่อใช้ตัวกรอง % สูงสุดหรือ % ต่ำสุด',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'ข้อมูลเชิงลึกไม่พร้อมใช้งานเมื่อใช้ตัวกรองด้านบนหรือด้านล่างและมีมากกว่าหนึ่งคอลัมน์ในฟิลด์',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'การคาดการณ์ไม่พร้อมใช้งานเมื่อใช้ตัวกรองด้านบนหรือด้านล่างและมีมากกว่าหนึ่งคอลัมน์ในฟิลด์',
	'forecast_title': 'คาดการณ์ล่วงหน้า',
	'forecast_show': 'แสดงการคาดการณ์',
	'forecast_toggle_on': 'เปิดการคาดการณ์ล่วงหน้า',
	'forecast_toggle_off': 'ปิดการคาดการณ์ล่วงหน้า',
	'statDetailsPerspectiveTitle': 'การวิเคราะห์',
	'emptyStatDetailsPanel': 'ไม่มีการวิเคราะห์เพิ่มเติมที่พร้อมใช้งานสำหรับวิชวลไลเซชันปัจจุบัน',
	'predict_errors': 'ข้อผิดพลาดการวิเคราะห์',
	'predict_warnings': 'คำเตือนการวิเคราะห์',
	'fpd_invalid_data_source': 'แหล่งข้อมูลนี้ไม่มีโมดูลสมาร์ทที่เชื่อมโยง',
	'fpd_network_issue': 'เกิดปัญหาขณะดำเนินการวิเคราะห์กับแหล่งข้อมูลนี้',
	'fpd_data_source_category': 'ไม่มีโมดูลสมาร์ท',
	'fpd_response_errors': 'ข้อผิดพลาดไดรเวอร์ที่แนะนำ',
	'fpd_response_warnings': 'คำเตือนไดรเวอร์ที่แนะนำ',
	'catalyst_service_bad_request': 'คำร้องขอที่ล้มเหลว',
	'catalyst_service_unkown_Id': 'พบ ID คำร้องขอที่ไม่รู้จัก',
	'catalyst_service_internal_server_error': 'ข้อผิดพลาดเซิร์ฟเวอร์ภายใน',
	'catalyst_service_generic_error': 'ข้อผิดพลาดเซอร์วิส Catalyst',
	'catalyst_service_error': 'เซอร์วิสนี้ไม่พร้อมใช้งานในปัจจุบัน',
	'propLegendPosition': 'ตำแหน่งของคำอธิบายสัญลักษณ์',
	'propLeft': 'ด้านซ้าย',
	'propRight': 'ด้านขวา',
	'propTop': 'บน',
	'propBottom': 'ล่าง',
	'propNone': 'ไม่มี',
	'propLegendDisplay': 'แสดงคำอธิบายสัญลักษณ์',
	'targetThicknessPlaceHolder': '%{min} ถึง %{max}',
	'targetThicknessErrorMsg': 'ป้อนจำนวนทั้งหมดระหว่าง %{min} ถึง %{max}',
	'possibleKeyDriver_DialogDriversLabelBegin': 'ไดรเวอร์ (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'เลือกแล้ว)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'รีเซ็ตเป็นดีฟอลต์',
	'possibelKeyDriver_AddNewDrivers': 'เพิ่มไดรเวอร์เพิ่มเติม',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'ค้นหาเพื่อเพิ่มไดรเวอร์เพิ่มเติม',
	'possibleKeyDrivers_MaxPossibleReached': 'ยกเลิกการเลือกบางไดรเวอร์เพื่อเพิ่มหรือเลือกไดรเวอร์อื่น',
	'possibleKeyDrivers_Recommended': 'ที่แนะนำ',
	'visRecommendedTypes': 'ชนิดการทำให้มองเห็นภาพที่แนะนำ',
	'visRecommender_smartsfailure': 'ข้อแนะนำเกี่ยวกับวิชวลไลเซชันไม่พร้อมใช้งานในปัจจุบัน',
	'visMore': 'อื่นๆ...',
	'visMoreTooltip': 'การทำให้มองเห็นภาพเพิ่มเติม',
	'visOtherTypes': 'ชนิดการทำให้มองเห็นภาพอื่น',
	'visChange': 'เปลี่ยนวิชวลไลเซชัน',
	'automaticTypeCaption': 'อัตโนมัติ',
	'propVisType': 'ชนิดของวิชวลไลเซชัน',
	'dlg_loading': 'กำลังโหลด...',
	'snippetListChartCaption': 'รายการส่วนประโยค',
	'convoClusterChartCaption': 'คลัสเตอร์การสนทนา',
	'areaChartCaption': 'พื้นที่',
	'barChartCaption': 'แท่ง',
	'columnChartCaption': 'คอลัมน์',
	'stackedbarChartCaption': 'แท่งแบบสแต็ก',
	'stackedcolumnChartCaption': 'คอลัมน์แบบสแต็ก',
	'bubbleChartCaption': 'บับเบิล',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'การวิเคราะห์ไดรเวอร์',
	'scatterChartCaption': 'Scatter',
	'lineChartCaption': 'เส้น',
	'pointChartCaption': 'จุด',
	'heatChartCaption': 'แผนผังความร้อน',
	'bulletChartCaption': 'สัญลักษณ์แสดงหัวข้อย่อย',
	'waterfallChartCaption': 'น้ำตก',
	'radarChartCaption': 'เรดาร์',
	'boxplotChartCaption': 'บ็อกซ์พล็อต',
	'pieChartCaption': 'วงกลม',
	'mapChartCaption': 'แม็พ',
	'radialBarChartCaption': 'รัศมี',
	'compositeChartCaption': 'เส้นและคอลัมน์',
	'wordCloudChartCaption': 'Word cloud',
	'networkChartCaption': 'เครือข่าย',
	'relationshipNetworkChartCaption': 'เครือข่ายความสัมพันธ์',
	'treemapChartCaption': 'แม็พแผนผัง',
	'packedBubbleChartCaption': 'บับเบิลที่แพ็ก',
	'hierarcicalPackedBubbleChartCaption': 'บับเบิลแบบลำดับชั้น',
	'spiralChartCaption': 'เกลียว',
	'decisionTreeChartCaption': 'แผนผังการตัดสินใจ',
	'legacyMapChartCaption': 'แผนที่มรดก',
	'sunburstChartCaption': 'แสงกระจาย',
	'visUsageComparison': 'การเปรียบเทียบ',
	'visUsageRelationships': 'ความสัมพันธ์',
	'visUsageTrend': 'แนวโน้ม',
	'visUsagePartsToWhole': 'ส่วนต่อทั้งหมด',
	'visUsageGeospatial': 'ภูมิสารสนเทศเชิงพื้นที่',
	'visUsageAdvanced': 'การวิเคราะห์ขั้นสูง',
	'visUsageTablesAndSummary': 'ตารางและสรุป',
	'visUsageSocialInsights': 'ข้อมูลเชิงลึกทางสังคม',
	'visUsageOther': 'อื่น ๆ',
	'autoBinActionText': 'จัดกลุ่มแบบอัตโนมัติ',
	'filterAutobinActionText': 'ถังกรอง',
	'memberCalculationActionText': 'การคำนวณสมาชิก',
	'toolbarActionCalculation': 'สร้างการคำนวณ',
	'toolbarActionEditCalculation': 'แก้ไขการคำนวณ',
	'topBottomRankLabel': 'อันดับ (%{label})',
	'toolbarDeleteFilterActionText': 'ลบตัวกรอง',
	'toolbarActionTopKeyDrivers': 'แสดงไดรเวอร์',
	'toolbarActionCustomGroup': 'กลุ่มแบบกำหนดเอง',
	'canNotCreateCustomGroup': 'เราไม่สามารถสร้างกลุ่มแบบกำหนดเองนี้ได้',
	'aria_label_datatable': 'ตารางข้อมูล',
	'summaryCaption': 'ยอดรวม',
	'MeasuresCaption': 'การวัด',
	'MeasuresGroupCaption': 'กลุ่มการวัด (%{count})',
	'ValuesCaption': 'ค่า',
	'turnInsightsOn': 'เปิดข้อมูลเชิงลึก',
	'turnInsightsOff': 'ปิดข้อมูลเชิงลึก',
	'decisionRules': 'กฎ',
	'decisionTree': 'แผนผังต้นไม้',
	'decisionSunburst': 'แผนผังแสงกระจาย',
	'switchToDecisionRules': 'สลับไปเป็นกฎการตัดสินใจ',
	'switchToDecisionTree': 'สลับไปเป็นแผนผังการตัดสินใจ',
	'data_group_less_then': 'น้อยกว่า %{rangeTo}',
	'data_group_to': '%{rangeFrom} ถึง < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} และสูงกว่า',
	'nullValueContent': '(ไม่มีค่า)',
	'sum': 'ผลรวม',
	'count': 'การนับ',
	'countdistinct': 'นับที่แตกต่าง',
	'avg': 'เฉลี่ย',
	'min': 'ต่ำสุด',
	'max': 'สูงสุด',
	'automatic': 'กำหนดเอง',
	'variance': 'Variance',
	'stddev': 'การเบี่ยงเบนมาตรฐาน',
	'median': 'ค่ามัธยฐาน',
	'calculated': 'ถูกคำนวณ',
	'none': 'ไม่มี',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'พร้อมต์ค่า',
	'inputLabelPrompt': 'ค่า',
	'inputPlaceholderPrompt': 'ป้อนค่า',
	'inputInvalidText': 'อินพุตไม่ถูกต้องสำหรับชนิด %{dataType}',
	'unSupportedPrompt': 'พร้อมต์ที่ไม่สนับสนุน',
	'missingDataSource': 'ไม่พบแหล่งข้อมูลที่ถูกต้อง',
	'unSupportedPromptType': 'สถานการณ์จำลองพร้อมต์ไม่ได้รับการสนับสนุน',
	'preAggregateLabel': 'ใช้ค่าพร้อมต์จากแหล่งข้อมูล',
	'postAggregateLabel': 'ใช้ค่าพร้อมต์ในรายงาน',
	'preAggregateText': 'ช่วงใช้ค่าในแหล่งข้อมูล ไม่ใช่ค่าที่ปรากฏในแดชบอร์ด',
	'defaultAggregation_count': 'การนับ',
	'defaultAggregation_countdistinct': 'นับที่แตกต่าง',
	'defaultAggregation_max': 'สูงสุด',
	'defaultAggregation_min': 'ต่ำสุด',
	'defaultAggregation_avg': 'เฉลี่ย',
	'defaultAggregation_sum': 'ผลรวม',
	'defaultAggregation_auto': 'อัตโนมัติ (%{aggregationType})',
	'keydriver_average': 'ค่าเฉลี่ยโดยรวม',
	'keydriver_up_down': 'กลุ่มที่ถูกไฮไลต์ด้วยค่าเฉลี่ยสูงหรือต่ำมีผลกระทบกับเป้าหมายมากกว่า กลุ่มที่มีค่าเฉลี่ยสูงหรือต่ำแบบไม่ปกติมีผลกระทบมากที่สุด',
	'keydriver_different': 'กลุ่มที่ถูกไฮไลต์มีการกระจายที่แตกต่างจากการกระจายโดยรวมอย่างมาก กลุ่มเหล่านี้มีผลกระทบกับเป้าหมายมากกว่า',
	'topOperator': 'บน',
	'bottomOperator': 'ล่าง',
	'topBottomFact': '%{operator} %{value}%{percent} เทียบกับ %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'ลบการนับอันดับแรก หรือสุดท้าย',
	'deleteTopBottomPercent': 'ลบ % อันดับแรกหรือสุดท้าย',
	'topBottomTitle': 'อ็อบเจ็กต์นี้เท่านั้น',
	'deleteTopBottom': 'ลบการนับอันดับแรก หรือสุดท้าย',
	'editTopBottom': 'แก้ไขการนับอันดับแรก หรือสุดท้าย',
	'editTopBottomCount': 'แก้ไขการนับอันดับแรก หรือสุดท้าย',
	'editTopBottomPercent': 'แก้ไข % อันดับแรกหรือสุดท้าย',
	'ariaDeleteTopBottomCountLabel': 'กดปุ่ม DELETE เพื่อลบการนับอันดับแรกหรือสุดท้าย',
	'ariaDeleteTopBottomPercentLabel': 'กดปุ่ม DELETE เพื่อลบ % อันดับแรกหรือสุดท้าย',
	'ariaEditTopBottomCountLabel': 'กดปุ่ม ENTER เพื่อแก้ไขการนับอันดับแรกหรือสุดท้าย',
	'ariaEditTopBottomPercentLabel': 'กดปุ่ม ENTER เพื่อแก้ไข % อันดับแรกหรือสุดท้าย',
	'ariaDeleteDrillStateLabel': 'กดปุ่ม ENTER เพื่อแก้ไขการนับอันดับแรกหรือสุดท้าย',
	'drillUpStateTitle': 'ดูรายละเอียด',
	'drillDownStateTitle': 'ดูโดยละเอียด',
	'ariaEditTopBottomLabel': 'กดปุ่ม ENTER เพื่อแก้ไขการนับอันดับแรกหรือสุดท้าย',
	'ariaDeleteTopBottomLabel': 'กดปุ่ม DELETE เพื่อลบการนับอันดับแรกหรือสุดท้าย',
	'allKeyDriversLabel': 'อัตโนมัติ (ไดรเวอร์ทั้งหมด)',
	'filter_drag_and_drop_single_dock': 'ลากและปล่อยข้อมูลที่นี่เพื่อกรอง',
	'filter_drag_and_drop_all_tabs': 'ลากและปล่อยข้อมูลที่นี่เพื่อกรองแท็บทั้งหมด',
	'filter_drag_and_drop_current_tab': 'ลากและปล่อยข้อมูลที่นี่เพื่อกรองแท็บนี้',
	'filter_empty_consume_mode': 'ไม่ได้ใช้ตัวกรองใด ๆ',
	'filterClearAllItems': 'เคลียร์ตัวกรองทั้งหมด',
	'filterDeleteAllItems': 'ลบตัวกรองทั้งหมด',
	'filterDockChevronLeft': 'เลื่อนผ่านข้อมูล',
	'filterDockChevronRight': 'เลื่อนผ่านข้อมูล',
	'filterIconLabel_Single': 'ตัวกรอง',
	'filterIconLabel_Global': 'แท็บทั้งหมด',
	'filterIconLabel_Tab': 'แท็บนี้',
	'filterIconTooltip_Single': 'ตัวกรอง',
	'filterIconTooltip_Global': 'กรองแท็บทั้งหมด',
	'filterIconTooltip_Tab': 'กรองแท็บนี้',
	'filterDropZoneTooltip_Single': 'กรองดร็อปโซน',
	'filterDropZoneTooltip_Global': 'กรองดร็อปโซนสำหรับแท็บทั้งหมด',
	'filterDropZoneTooltip_Tab': 'กรองดร็อปโซนสำหรับแท็บนี้',
	'filterOverflowMenu': 'เพิ่มขึ้น',
	'expand': 'ขยาย',
	'collapse': 'ยุบ',
	'filterDockItemNameAriaLabel': 'กด enter เพื่อเรียกใช้งานไดอะล็อกตัวกรองและกำหนดตัวกรอง',
	'filterItemCanvasMove': 'เพิ่มไปยังภาพวาด',
	'filterItemDelete': 'ลบตัวกรอง',
	'filterInvertRange': 'ทุกสิ่งยกเว้น: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'ไม่หลังจาก %{from}',
	'filter_date_after': 'หลังจาก %{from}',
	'filter_date_before_except': 'ไม่ก่อน %{to}',
	'filter_date_before': 'ก่อน %{to}',
	'filter_date_between_except': 'ไม่ระหว่าง %{from}-%{to}',
	'filter_date_between': 'ระหว่าง %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'ทั้งหมด',
	'filter': 'ตัวกรอง',
	'filterExcept': 'ยกเว้น %{values}',
	'filterDockToolbarButtonLabel': 'Filter dock',
	'navigateTitle': 'นำทางไปยัง',
	'navigateSelectColumn': 'เลือกคอลัมน์',
	'navigateSelectPath': 'เลือกพาธการนำทาง',
	'current_nav_group': 'กลุ่มการนำทางปัจจุบันคือ %{navigation_group_name}',
	'next': 'ถัดไป',
	'previous': 'ก่อนหน้า',
	'multiselectMsg': '%{count} ที่เลือกไว้',
	'errMsgFilterItemMissingTitle': 'ไม่สามารถโหลดค่าตัวกรอง %{itemName} เนื่องจากค่าเหล่านี้ไม่พร้อมใช้งานกับชุดข้อมูลนี้',
	'errMsgFilterItemGenericTitle': 'ไม่สามารถโหลดค่าตัวกรองได้',
	'textFilterItemsNotFound': 'ไม่มีไอเท็ม',
	'nullValueLabel': '(ว่าง)',
	'filterConditionLabel': 'เงื่อนไขตัวกรอง',
	'filter_includesAll': 'รวมทั้งหมด',
	'filter_allMembersOfSet': 'สมาชิกทั้งหมดของชุด',
	'modelFilter': 'ตัวกรอง',
	'filtersTitle': 'คุณสมบัติของตัวกรอง',
	'search': 'ค้นหา',
	'clearTextFilterValue': 'เคลียร์',
	'invertFilterSelection': 'กลับ',
	'modellingLoading': 'กำลังโหลด...',
	'searchAll': 'ค้นหาคอลัมน์ทั้งหมด',
	'toolbarActionPossibleKeyDrivers': 'แก้ไขขอบเขต',
	'toolbarActionPossibleKeyDriversSubTitle': 'ลากไอเท็มจากซ้ายเพื่อพิจารณาในแผนภูมิการวิเคราะห์ไดรเวอร์',
	'toolbarActionSort': 'เรียงลำดับ',
	'toolbarActionSortAscending': 'น้อยไปหามาก',
	'toolbarActionSortDescending': 'จากมากไปหาน้อย',
	'toolbarActionSortAuto': 'อัตโนมัติ (%{sortOrder})',
	'toolbarActionSortCustom': 'กำหนดเอง',
	'toolbarActionFormat': 'จัดรูปแบบข้อมูล',
	'toolbarActionFormatText': 'จัดรูปแบบข้อมูล (ข้อความ)',
	'toolbarActionFormatAbbreviation': 'ย่อ',
	'toolbarActionFormatNone': 'อัตโนมัติ',
	'toolbarActionFilter': 'ตัวกรอง',
	'toolbarActionTopBottom': 'ด้านบนหรือด้านล่าง',
	'toolbarActionRmvShape': 'ลบรูปร่าง',
	'toolbarActionToggleShapeDrop': 'รูปร่างอินโฟกราฟิก',
	'toolbarActionToggleShapeDropTitle': 'สร้างอินโฟกราฟิก',
	'toolbarActionToggleShapeDropText': 'ลากรูปร่างไปยังฟิลด์นี้เพื่อสร้างอินโฟกราฟิก',
	'toolbarActionAggregationType': 'การสรุป',
	'toolbarDeleteActionText': 'ลบคอลัมน์',
	'toolbarTextActionText': 'ข้อความสไตล์',
	'toolbarActionFilterLocalKeepSelected': 'เก็บไว้',
	'toolbarActionFilterLocalExcludeSelected': 'ไม่รวม',
	'toolbarActionFilterAllKeepSelected': 'ตัวกรอง',
	'toolbarActionSimpleCalculation': 'การคำนวณแบบง่าย',
	'toolbarActionDrillBack': 'ย้อนกลับ',
	'toolbarActionDrillUp': 'ดูรายละเอียด',
	'toolbarActionDrillDown': 'ดูโดยละเอียด',
	'toolbarActionJumpTo': 'การเจาะลึก',
	'toolbarActionNavigate': 'นำทาง',
	'toolbarActionCreateFilterGroup': 'สร้างการเชื่อมต่อใหม่',
	'toolbarActionDisconnectFilterGroup': 'หยุดลิงก์ทั้งหมด',
	'toolbarActionLinkFilterGroup': 'เพิ่มไปยังการเชื่อมต่อที่มีอยู่',
	'toolbarActionLassoSelect': 'เลือกเครื่องมือ',
	'toolbarActionRefreshDeveloperWidget': 'รีเฟรช',
	'textFontFamilySubClassHairline': 'เส้นบางเฉียบ',
	'textFontFamilySubClassThin': 'Thin',
	'textFontFamilySubClassThinItalic': 'บางเอียง',
	'textFontFamilySubClassExtraLight': 'บางพิเศษ',
	'textFontFamilySubClassExtraLightItalic': 'บางเอียงพิเศษ',
	'textFontFamilySubClassLight': 'อ่อน',
	'textFontFamilySubClassLightItalic': 'บางเอียง',
	'textFontFamilySubClassRegular': 'ปกติ',
	'textFontFamilySubClassRegularItalic': 'เอียงปกติ',
	'textFontFamilySubClassItalic': 'ตัวเอียง',
	'textFontFamilySubClassMedium': 'กลาง',
	'textFontFamilySubClassMediumItalic': 'ตัวเอียงขนาดกลาง',
	'textFontFamilySubClassHeavy': 'ตัวหนา',
	'textFontFamilySubClassHeavyItalic': 'ตัวเอียงหนา',
	'textFontFamilySubClassDemiBold': 'ตัวหนาครึ่งหนึ่ง',
	'textFontFamilySubClassDemiBoldItalic': 'ตัวเอียงหนาครึ่งหนึ่ง',
	'textFontFamilySubClassBold': 'ตัวหนา',
	'textFontFamilySubClassBoldItalic': 'ตัวเอียงหนา',
	'textFontFamilySubClassExtraBold': 'ตัวหนาพิเศษ',
	'textFontFamilySubClassExtraBoldItalic': 'ตัวเอียงหนาพิเศษ',
	'textFontFamilySubClassBlack': 'สีดำ',
	'textFontFamilySubClassBlackItalic': 'ตัวเอียงสีดำ',
	'textFontFamilySubClassStencil': 'สเตนซิล',
	'dlg_ascending': 'จากน้อยไปมาก',
	'dlg_descending': 'จากมากไปน้อย',
	'dlg_custom': 'กำหนดเอง',
	'dlg_none': 'ไม่มี',
	'dlg_hierarchy': 'ลำดับชั้น',
	'dlg_namedSet': 'ชุดชื่อที่ระบุ',
	'dlg_rank': 'rank',
	'visualizationLabel': 'วิชวลไลเซชัน',
	'chartLabel': 'แผนภูมิ %{chartName}ิ',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'กด F12 เพื่อนำทางภายในวิดเจ็ต',
	'f10KeyDescription': 'กด F10 เพื่อเรียกทำงานมุมมองโฟกัสวิดเจ็ต',
	'playButtonLabel': 'เล่น',
	'dataPlayerValueListLabel': 'ค่าของเครื่องเล่นข้อมูล',
	'localFilterTitle': 'อ็อบเจ็กต์นี้เท่านั้น',
	'globalFilterTitle': 'อ็อบเจ็กต์ทั้งหมด',
	'deleteFilter': 'ลบตัวกรอง',
	'editFilter': 'แก้ไขตัวกรอง',
	'ariaEditFilterLabel': 'กดปุ่ม ENTER เพื่อแก้ไขตัวกรอง',
	'ariaDeleteFilterLabel': 'กดปุ่ม DELETE เพื่อลบตัวกรอง',
	'measureFilterBetween': 'ระหว่าง %{lowerBound} และ %{upperBound}',
	'measureFilterNotBetween': 'ไม่อยู่ระหว่าง %{lowerBound} และ %{upperBound}',
	'dimFilterIn': 'รวม: %{in}',
	'dimFilterNotIn': 'แยกออก: %{out}',
	'gtFilter': 'หลังจาก %{lowerBound}',
	'ltFilter': 'ก่อน %{upperBound}',
	'ariaEditPrompt': 'กดปุ่ม ENTER เพื่อเปลี่ยนค่าพร้อมต์',
	'dataPointFilterTitle': 'จุดข้อมูล',
	'dataPointFilterIncludeSummary': 'รวม %{valueCount} จุดข้อมูล',
	'dataPointFilterExcludeSummary': 'แยก %{valueCount} จุดข้อมูล',
	'widgetFiltersLabel': 'ตัวกรองวิดเจ็ต',
	'coachMarkTitleSpiralTarget': 'แก้ไขขอบเขต',
	'coachMarkContentSpiralTarget': 'นี่เป็นตำแหน่งที่คุณสามารถเข้าถึงและปรับเปลี่ยนการเลือกไดรเวอร์สำหรับเป้าหมายของคุณ',
	'srILVTreeLabel': 'ลิสต์',
	'geomapUnrecognizedLocations': 'ตำแหน่งที่ไม่รู้จัก:',
	'geomapAmbiguousLocations': 'ภูมิภาคที่ไม่ชัดเจน:',
	'visualizationNotifications': 'การแจ้งเตือนวิชวลไลเซชัน:',
	'dataNotifications': 'การแจ้งเตือนข้อมูล:',
	'autobinSuggestion': 'เปิดใช้งานการจัดกลุ่มแบบอัตโนมัติ',
	'LIVE_empty_visualization_hint_title': 'บิลด์วิชวลไลเซชันของคุณ',
	'LIVE_empty_visualization_hint_description': 'ลากข้อมูลที่นี่หรือลงบนฟิลด์',
	'LIVE_slots_required_field_description': '%{asterisk} ระบุฟิลด์ที่จำเป็น',
	'LIVE_slots_drag_and_drop_description': 'ลากและปล่อยข้อมูลลงในฟิลด์ด้านบนเพื่อสร้างและกรองวิชวลไลเซชัน',
	'dwErrorLoadingAvailableVisualizations': 'เราไม่สามารถโหลดนิยามการวิชวลไลเซชันที่มี',
	'moreDataIndicator': 'ข้อมูลของคุณถูกตัดออกที่ %{threshold} ไอเท็ม ใช้กับตัวกรองเพื่อแสดงข้อมูลให้น้อยลง',
	'nonCtxTopBottomInvalid': 'ไม่สนับสนุนการกำหนดกฎด้านบนหรือด้านล่างโดยไม่มีบริบทสำหรับการอ้างอิงไขว้ ซึ่งถูกลบออกจากมุมมองอ้างอิงไขว้นี้  ให้กำหนดกฎใหม่บนหมวดหมู่อย่างน้อยหนึ่งหมวดหมู่ในบริบทของ %{columnName}',
	'dwErrorLoadingVisualizationNotFound': 'เราไม่สามารถโหลดอ็อบเจ็กต์ เนื่องจากไม่มีนิยามวิชวลไลเซชัน',
	'dwErrorLoadingVisualizationListNotFound': 'เราไม่สามารถโหลดวิชวลไลเซชัน',
	'dwErrorRunningQuery': 'เราไม่สามารถดึงข้อมูลจากชุดข้อมูล %{datasetName}',
	'dwErrorGeoData': 'เรามีปัญหาในการแสดงข้อมูลภูมิศาสตร์ในแม็พ โปรดเลือกชนิดวิชวลไลเซชันอื่น',
	'dwPromptSignonCancelWarning': 'ไม่มีข้อมูลสำหรับวิชวลไลเซชันนี้ โปรดระบุหนังสือรับรองที่ถูกต้อง',
	'dwErrorMissingDataset': 'เราไม่สามารถโหลดวิชวลไลเซชัน เนื่องจากข้อมูลที่เกี่ยวข้อง "%{datasetName}" ไม่พร้อมใช้งาน',
	'dwErrorRenderingVisualization': 'เราไม่สามารถโหลดวิชวลไลเซชันนี้',
	'dwErrorVisualizationTooSmall': 'วิชวลไลเซชันมีขนาดเล็กเกินไปที่จะแสดงข้อมูลที่มี ทำให้วิชวลไลเซชันมีขนาดใหญ่ขึ้นหรือจำกัดจำนวนข้อมูลที่มี',
	'errorSourceNotFound': 'เราไม่สามารถโหลดวิชวลไลเซชัน เนื่องจากแหล่งข้อมูลที่เกี่ยวข้อง "%{sourceName}" ไม่พร้อมใช้งาน',
	'errorActionNotSupported': 'ไม่สนับสนุนแอ็คชันนี้สำหรับแหล่งข้อมูล "%{sourceName}"',
	'errorMeasureNotSupportedOnMultiEdges': 'วิชวลไลเซชันมีการวัดแบบหลาย edge ซึ่งไม่ได้รับการสนับสนุนอีกต่อไป โปรดวางการวัดบน edge เดียวเท่านั้น',
	'errorExceedAllowableValue': 'จำนวนเซลล์โดยประมาณเกินกว่าค่าที่อนุญาตคือ 100000 โปรดใช้การกรองกับชุดที่คาดการณ์ไว้เพื่อลดจำนวนเซลล์',
	'propScaleLabel': 'จำนวนของไอคอน',
	'propScaleDescription': 'เลือกจำนวนของไอคอน',
	'propScaleFew': 'ต่ำ',
	'propScaleDefault': 'ดีฟอลต์',
	'propScaleMany': 'สูง',
	'lastRefresh': 'รีเฟรชล่าสุด: %{timeInterval} ที่ผ่านมา',
	'widgetTimer': 'จับเวลาวิดเจ็ต',
	'datasetItemsUnavailable': 'ไอเท็มชุดข้อมูลบางไอเท็มที่ใช้ในวิชวลไลเซชันนี้ไม่พร้อมใช้งาน',
	'datasetItemUnavailable': 'ไอเท็มชุดข้อมูลนี้ไม่พร้อมใช้งาน',
	'retry': 'ลองอีกครั้ง',
	'widgetConditionalFormatLabel': 'สลับตัวควบคุมรูปแบบแบบมีเงื่อนไข',
	'widgetConditionalFormatTitle': 'แก้ไขสีการจัดรูปแบบแบบมีเงื่อนไข',
	'crosstabName': 'อ้างอิงไขว้',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'ไม่ระบุ',
	'summaryLabel': '%{label} ที่มีค่า %{value}',
	'infographicLabel': '%{label} ที่มีค่า %{value}',
	'warning': 'คำเตือน',
	'swapRowsAndColumns': 'สลับแถวและคอลัมน์',
	'hideSummariesLabel': 'ซ่อนสรุป',
	'showSummariesLabel': 'แสดงสรุป',
	'hideRowColumn': 'ซ่อน',
	'showAllRowColumn': 'แสดงทั้งหมด',
	'dataAssetPropertiesLabel': 'คุณสมบัติวิชวลไลเซชัน',
	'evAdd': 'เพิ่มคอลัมน์',
	'evCollapse': 'ยุบ',
	'evColumns': 'คอลัมน์',
	'evLocalFilters': 'ตัวกรองโลคัล',
	'evExpand': 'ขยาย',
	'evFilterTooltip': 'ตัวกรอง',
	'missingColumn': 'ไม่มี: %{columnLabel}',
	'missingFiltering': 'ไม่มีตัวกรองในคอลัมน์:',
	'missingDataItem': 'ไม่พบไอเท็มข้อมูลที่อ้างอิง "%{dataItemId}" ในวิดเจ็ต',
	'heatByLabel': 'ความร้อนตาม',
	'toolbarChangeVisualization': 'เปลี่ยนวิชวลไลเซชัน',
	'modellingRelatedTablesNoneFound': 'ไม่พบตารางที่เกี่ยวข้อง',
	'processing': 'กำลังประมวลผล...',
	'errorCellWarning': 'ไม่สามารถคำนวณค่าสรุปบางค่าได้',
	'aggregateTypeToggler': 'แสดงชนิดการรวม',
	'maxColumnsExceeded': 'เกินจำนวนสูงสุดของคอลัมน์แล้ว %{columns} ถูกดร็อป',
	'unboundColumns': 'ไม่สามารถใช้คอลัมน์ต่อไปนี้: %{columns}',
	'unboundColumn': 'ไม่สามารถใช้คอลัมน์ต่อไปนี้: %{columns}',
	'recommendRequestFailed': 'คำร้องขอคำแนะนำล้มเหลว โปรดติดต่อผู้ดูแลระบบของคุณ',
	'visualizationDoesNotSupportOLAP': 'เราไม่สามารถสร้างวิชวลไลเซชันนี้ที่อิงตามแหล่งข้อมูล OLAP โปรดใช้แหล่งข้อมูลอื่นที่สนับสนุน',
	'showDataBehindVizLabel': 'แสดงข้อมูล',
	'showDataBehindVizNotSupportedLabel': 'ไม่รองรับการแสดงข้อมูลสำหรับวิชวลไลเซชันชนิดนี้',
	'exploreData': 'สำรวจ...',
	'newExplore': 'การสำรวจใหม่',
	'thumbnails_error_fetching': 'เกิดข้อผิดพลาดขณะเรียกข้อมูลภาพขนาดย่อ',
	'loadedThumbnailImage': 'โหลดอิมเมจภาพขนาดเล็กของวิชวลไลเซชัน %{visType}',
	'autobinAxisLabel': 'กลุ่ม',
	'recommended_visualizations': 'วิชวลไลเซชันที่แนะนำ',
	'all_visualizations': 'วิชวลไลเซชันทั้งหมด',
	'edit': 'แก้ไข',
	'selectTargetDialogTitle': 'เลือกเป้าหมายที่เจาะลึก',
	'noTargetInCM': 'ไม่พบเป้าหมายของการเจาะลึก',
	'errorDrillDefinition': 'มีบางอย่างผิดปกติขณะที่คุณเพิ่มหรือแก้ไขนิยามการเจาะลึก',
	'errorDrillToTarget': 'เกิดข้อผิดพลาดในการเจาะลึกไปยัง "%{targetName}"',
	'drillThroughMappingViewLabel': 'กำหนดคอลัมน์จากแดชบอร์ดของคุณให้แสดงพร้อมต์ของรายงานเป้าหมาย',
	'drillthroughScopeRadioLabel': 'ใช้นิยามนี้กับ:',
	'drillthroughScopeRadioOptionVisualization': 'เฉพาะวิชวลไลเซชันนี้',
	'drillthroughScopeRadioOptionConnection': 'วิชวลไลเซชันในการเชื่อมต่อเหมือนกันที่ใช้แหล่งข้อมูลเดียวกัน',
	'drillthroughScopeRadioOptionDashboard': 'วิชวลไลเซชันใดๆ บน %{perspective} ที่ใช้แหล่งข้อมูลเดียวกัน',
	'drillThroughParametersColumnTitle': '"%{targetName}" พร้อมต์:',
	'drillThroughMetadataColumnTitle': '"%{boardName}" คอลัมน์ข้อมูล:',
	'drillThroughDefinitionNoParameter': 'เป้าหมายนิยามการเจาะลึกไม่มีพร้อมต์',
	'drillThroughDefinitionErrorQueryingReport': 'แก้ไขปัญหาที่เกิดขึ้นด้วยรายงานเป้าหมาย จากนั้นลองสร้างนิยามการเจาะลึกดูรายละเอียดอีกครั้ง',
	'drillThroughDefinitionErrorDlgTitle': 'มีบางอย่างไม่ถูกต้อง',
	'dlg_back': 'ย้อนกลับ',
	'dlg_close': 'ปิด',
	'dlg_ok': 'ตกลง',
	'dlg_cancel': 'ยกเลิก',
	'dlg_apply': 'ใช้',
	'dlg_create': 'สร้าง',
	'dlg_done': 'เสร็จสิ้น',
	'drillthrough_unsaveMsg': 'ดำเนินการต่อไปโดยไม่บันทึก"%{name}" หรือไม่?',
	'drillthrough_jumpTo': 'นิยามการเจาะลึก: %{name}',
	'drillthrough_jumpToLabel': 'การเจาะลึก',
	'drillthrough_manage': 'จัดการ...',
	'drillthrough_addNewTarget': 'เพิ่มนิยามการเจาะลึกใหม่',
	'drillthrough_manageJumpPaths': 'จัดการนิยามการเจาะลึก',
	'drillthrough_manageJumpPaths_edit': 'แก้ไข "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'ลบ "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'เพิ่มนิยามการเจาะลึกอื่น',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'ยืนยันการลบ',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'คุณแน่ใจว่าต้องการลบการเจาะลึก "%{name}" หรือไม่?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'ทำซ้ำชื่อการเจาะลึก',
	'drillthrough_definitionMessage': 'มีการเจาะลึก "%{name}" อยู่แล้ว ให้ตั้งชื่อใหม่',
	'drillthrough_jumpToTarget_notFound': 'ไม่พบเป้าหมายสำหรับการเจาะลึก "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'ไม่มีบริบทที่จะผ่านไปยังรายงานเป้าหมาย',
	'drillthrough_titleLabel': 'ชื่อ',
	'drillthrough_create_dialogTitle': 'สร้างนิยามการเจาะลึก',
	'drillthrough_edit_dialogTitle': 'แก้ไขนิยามการเจาะลึก',
	'drillthrough_subTitle': 'บริบทของวิชวลไลเซชันในแหล่งข้อมูลของคุณถูกใช้เพื่อกรองเป้าหมาย %{perspective}',
	'drillthrough_selectColumn': 'เลือกคอลัมน์',
	'noPrompt': 'ไม่แสดงพร้อมต์',
	'promptDialog': 'ไดอะล็อกพร้อมต์ %{promptType}',
	'formatAutoDescription': 'ระบุรูปแบบที่สืบทอดจากแหล่งข้อมูลและวิชวลไลเซชันของคุณโดยอัตโนมัติ',
	'formatDefaultDescription': 'ระบุรูปแบบที่สืบทอดจากระบบโดยดีฟอลต์',
	'createCustomGroupAction': 'สร้างกลุ่มข้อมูล',
	'removeCustomGroupAction': 'ลบกลุ่มข้อมูล',
	'editCustomGroupAction': 'แก้ไขกลุ่มข้อมูล',
	'renameCustomGroupAction': 'เปลี่ยนชื่อกลุ่มข้อมูล',
	'createCustomGroupErrorToast': 'ไม่สามารถสร้างกลุ่มข้อมูลของคุณ',
	'removeCustomGroupErrorToast': 'ไม่สามารถลบกลุ่มข้อมูลของคุณ',
	'editCustomGroupErrorToast': 'ไม่สามารถแก้ไขกลุ่มข้อมูลของคุณ',
	'renameCustomGroupErrorToast': 'ไม่สามารถเปลี่ยนชื่อกลุ่มข้อมูลของคุณ',
	'customGroupLabel': 'สร้างกลุ่มข้อมูล',
	'ungroupCustomGroupLabel': 'ยกเลิกกลุ่ม',
	'renameCustomGroupLabel': 'เปลี่ยนชื่อ',
	'createCustomGroupLabel': 'สร้าง',
	'customGroupingLabel': '%{columnLabel} (กลุ่ม)',
	'createCustomSort': 'สร้างการเรียงลำดับที่กำหนดเอง',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'เลือกไอเท็มที่พร้อมใช้งาน จากนั้นเรียงลำดับไอเท็มอีกครั้งเพื่อสร้างการเรียงลำดับที่กำหนดเอง',
	'availableItems': 'ไอเท็มที่พร้อมใช้งาน',
	'selectAll': 'เลือกทั้งหมด',
	'customSortOrder': 'ลำดับการเรียงลำดับที่กำหนดเอง',
	'selectAvailableItemsDesc': 'เลือกไอเท็มที่พร้อมใช้งาน จากนั้นเรียงลำดับไอเท็มที่นี่',
	'moveToTop': 'เลื่อนขึ้นด้านบนสุด',
	'clear': 'เคลียร์',
	'sortRemainingItemsBy': 'เรียงลำดับไอเท็มที่เหลืออยู่ตาม',
	'removeAll': 'ลบทั้งหมด',
	'resetTooltip': 'ไอเท็มทั้งหมดจะถูกลบออกจากรายการ %{customSortOrder} และ ดร็อปดาวน์ %{sortRemainingItemsBy} จะถูกแปลงกลับเป็นดีฟอลต์',
	'manyItemsWarning': 'การเลือกไอเท็มจำนวนมากอาจส่งผลต่อประสิทธิภาพการทำงานของแดชบอร์ดของคุณ',
	'manyItemsSelected': 'มีการเลือกมากกว่า %{maxItems} ไอเท็ม ซึ่งอาจส่งผลต่อประสิทธิภาพการทำงานของแดชบอร์ดของคุณ.',
	'somethingWentWrong': 'ขออภับ มีบางอย่างไม่ถูกต้อง',
	'tryAgain': 'ลองอีกครั้ง',
	'customSortLabel': 'เรียงลำดับที่กำหนดเอง',
	'applyError': 'ไม่สามารถใช้ %{action}',
	'searchReturnedNoResults': 'ขออภัย การค้นหาของคุณไม่ได้ผลลัพธ์ใด ๆ',
	'extVisSystem': 'ระบบ',
	'extVisCustom': 'กำหนดเอง',
	'customVisTestVisualization': 'ทดสอบวิชวลไลเซชัน',
	'extVisCustomVisPreview': 'แสดงตัวอย่าง',
	'extVisCustomPreviewWidgets': 'วิดเจ็ตนักพัฒนา',
	'extVisCustomVVisualization': 'วิชวลไลเซชัน',
	'extVisCustomVisuals': 'วิชวลแบบกำหนดเอง',
	'noPermissionToManage': 'คุณไม่มีสิทธิในการจัดการวิชวลไลเซชันแบบกำหนดเอง',
	'extVisCustomUpdate': 'อัพเดต',
	'extVisCustomDelete': 'ลบ',
	'extVisNoCustomVisuals': 'ไม่มีวิชวลแบบกำหนดเอง',
	'extVisNoCustomVisualsMsg': 'ไม่มีวิชวลแบบกำหนดเองในองค์กรของคุณในตอนนี้',
	'extVisAddCustomVisual': 'เพิ่มวิชวลแบบกำหนดเอง',
	'extVisNoCustomVisualsAdminMsg': 'ไม่มีวิชวลแบบกำหนดเองในตอนนี้ ให้เพิ่มวิชวลเพื่อเริ่มใช้งาน',
	'extVisNoSDKConnection': 'ไม่ได้สร้างการเชื่อมต่อกับไฟล์โลคัลของคุณ',
	'extVisNoSDKPreviewMsg': 'เมื่อต้องการแสดงตัวอย่างวิชวลไลเซชันของคุณ โปรดสร้างการเชื่อมต่อ',
	'extVisMore': 'เพิ่มขึ้น',
	'extVisDeleteDialogTitle': 'ลบวิชวลแบบกำหนดเอง',
	'extVisDeleteDialogBody': 'คุณแน่ใจว่าต้องการลบวิชวลไลเซชันแบบกำหนดเองนี้หรือไม่? ซึ่งอาจถูกใช้อยู่โดยแดชบอร์ดและรายงานอื่น',
	'extVisDeleteConfirmation': 'วิชวลแบบกำหนดเองของคุณถูกลบแล้ว',
	'extVisDeleteError': 'ไม่สามารถลบวิชวลแบบกำหนดเองของคุณได้ %{msg}',
	'extVisCloseToast': 'ปิดเดี๋ยวนี้',
	'extVisAdd': 'วิชวลแบบกำหนดเองของคุณถูกเพิ่มเรียบร้อยแล้ว',
	'extVisAddError': 'ไม่สามารถเพิ่มวิชวลแบบกำหนดเองของคุณ %{msg}',
	'extVisUpdate': 'วิชวลแบบกำหนดเองของคุณถูกอัพเดตเรียบร้อยแล้ว',
	'extVisUpdateError': 'ไม่สามารถอัพเดตวิชวลแบบกำหนดเองของคุณ %{msg}',
	'extVisAddProgress': 'กำลังอิมพอร์ต %{name}',
	'extVisUpdateProgress': 'การอัพเดต %{name}',
	'extPermissionTitle': 'การเข้าถึงถูกจำกัดหรือวิชวลแบบกำหนดเองถูกลบ',
	'extPermissionBody': 'ไม่สามารถดูวิชวลแบบกำหนดเองนี้ได้ เนื่องจากถูกลบไปแล้วหรือถูกจำกัดการเข้าถึง',
	'customVizSaveWarning': 'ไม่สามารถบันทึกวิชวลแบบกำหนดเองของคุณได้ ยังไม่ได้อิมพอร์ต',
	'schematicTestCaption': 'ทดสอบแผนผัง',
	'schematicServiceRequestError': 'ข้อผิดพลาดของเซอร์วิสแผนผัง',
	'extVisPreviewMessage': 'นี่เป็นการแสดงตัวอย่าง ยังไม่ได้เพิ่มวิชวลไลเซชันให้กับผลิตภัณฑ์',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'ไม่ได้กำหนด',
	'kpiDefaultTargetLabel': 'เป้าหมาย',
	'kpiNonNumericTarget': 'ค่าเป้าหมายต้องเป็นตัวเลข',
	'kpiManualTargetSlotFilled': 'ค่าถูกใช้ในฟิลด์',
	'kpiAutoValueSize': 'อัตโนมัติ',
	'kpiUnableDrawSparklineLabel': 'ไม่สามารถวาดสปาร์คไลน์ได้',
	'kpiUnableDrawSparklineInfo': 'สปาร์คไลน์ต้องการจุดอย่างน้อยสองจุดในเวลา เปลี่ยนข้อมูลหรือปรับตัวกรองเพื่อดูสปาร์คไลน์',
	'conditionalFormattingTextColor': 'สีข้อความ',
	'suppression': 'การยับยั้ง',
	'suppressNone': 'ไม่มี',
	'suppressRowsAndColumns': 'แถวและคอลัมน์',
	'suppressRows': 'แถว',
	'suppressColumns': 'คอลัมน์',
	'enableSuppression': 'เปิดใช้งานการยับยั้ง',
	'disableSuppression': 'ปิดใช้งานการยับยั้ง',
	'loadVisDefinitionError': 'ไม่สามารถโหลดนิยามสำหรับวิชวลไลเซชัน %{id}',
	'emptyVisualization': 'วิชวลไลเซชันว่าง',
	'expandCollapse': 'ขยาย & ยุบ',
	'expandBtnLabel': 'ขยาย',
	'collapseBtnLabel': 'ยุบ',
	'prop_sizeInputNonNumericValue': 'ค่าต้องเป็นตัวเลข',
	'prop_sizeValueShouldBeHigher': 'ค่าต้องมากกว่า %{value}',
	'fontPropLabel': 'ตระกูลของฟอนต์',
	'fontSizePropLabel': 'ขนาดของฟอนต์',
	'sectionItemAxisTitle': 'หัวเรื่องแกนไอเท็ม',
	'sectionItemAxisLabel': 'เลเบลแกนไอเท็ม',
	'sectionValueAxisTitle': 'หัวเรื่องแกนค่า',
	'sectionValueAxisLabel': 'เลเบลแกนค่า',
	'styletext-widget.legend': 'คำอธิบายสัญลักษณ์',
	'styletext-itemAxis.ticks.labels': 'เลเบลแกน',
	'styletext-valueAxis.title': 'หัวเรื่องของแกน',
	'styletext-itemAxis.title': 'หัวเรื่องของแกน',
	'styletext-labels': 'เลเบลข้อมูล',
	'styletext-valueAxis.line.title': 'หัวเรื่องของเส้น',
	'styletext-cellValue': 'ค่า',
	'styletext-values': 'ค่า',
	'styletext-rowHeading': 'ส่วนหัวของแถว',
	'styletext-columnHeading': 'ส่วนหัวของคอลัมน์',
	'fontFamily': 'ตระกูล',
	'fontSize': 'ขนาด',
	'visExportFileName': 'วิชวลไลเซชัน',
	'ds-missingDataSet': 'ไม่พบชุดข้อมูล โปรดตรวจดูให้แน่ใจว่ามีการสร้างชุดข้อมูลสำเร็จ',
	'ds-missingDashboardId': 'โปรดบันทึกแดชบอร์ดก่อนสร้างชุดข้อมูล',
	'ds-unsupportedDataSourceType': 'ไม่สนับสนุนชนิดแหล่งข้อมูล %{type}',
	'dataCache': 'แคชข้อมูล',
	'dataCache_on': 'เปิด',
	'dataCache_off': 'ไม่มีแคช',
	'dataCache_auto': 'อัตโนมัติ',
	'queryOptimization': 'การเพิ่มประสิทธิภาพการเคียวรี'
});
